import { INVOICE_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
    getInvoiceLoading: false,
    getInvoiceSuccess: false,
    getInvoiceFailure: false,
    getInvoiceError: null,
    addInvoiceLoading: false,
    addInvoiceSuccess: false,
    addInvoiceFailure: false,
    addInvoiceError: null,
    deleteInvoiceLoading: false,
    deleteInvoiceSuccess: false,
    deleteInvoiceFailure: false,
    deleteInvoiceError: null,
    invoiceList: []
}

export const invoiceReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INVOICE_REQUEST.GET_INVOICE_REQUEST:
            return {
                ...state,
                getInvoiceLoading: true,
                getInvoiceSuccess: false,
                getInvoiceFailure: false,
                getInvoiceError: null
            }
        case INVOICE_REQUEST.GET_INVOICE_SUCCESS:
            return {
                ...state,
                getInvoiceLoading: false,
                getInvoiceSuccess: true,
                getInvoiceFailure: false,
                getInvoiceError: null,
                invoiceList: action.payload
            }
        case INVOICE_REQUEST.GET_INVOICE_FAILURE:
            return {
                ...state,
                getInvoiceLoading: false,
                getInvoiceSuccess: false,
                getInvoiceFailure: true,
                getInvoiceError: action.payload
            }
        case INVOICE_REQUEST.ADD_INVOICE_REQUEST:
            return {
                ...state,
                addInvoiceLoading: true,
                addInvoiceSuccess: false,
                addInvoiceFailure: false,
                addInvoiceError: null
            }
        case INVOICE_REQUEST.ADD_INVOICE_SUCCESS:
            let newInvoices = state.invoiceList;
            newInvoices.push(action.payload)
            return {
                ...state,
                getInvoiceLoading: false,
                getInvoiceSuccess: true,
                getInvoiceFailure: false,
                getInvoiceError: null,
                invoiceList: newInvoices
            }
        case INVOICE_REQUEST.ADD_INVOICE_FAILURE:
            return {
                ...state,
                addInvoiceLoading: false,
                addInvoiceSuccess: false,
                addInvoiceFailure: true,
                addInvoiceError: action.payload
            }
        case INVOICE_REQUEST.DELETE_INVOICE_REQUEST:
            return {
                ...state,
                deleteInvoiceLoading: true,
                deleteInvoiceSuccess: false,
                deleteInvoiceFailure: false,
                deleteInvoiceError: null,
            }
        case INVOICE_REQUEST.DELETE_INVOICE_SUCCESS:
            let invoices = state.invoiceList;
            for (let i = 0; i < state.invoiceList.length; i++) {
                if (invoices[i].invoiceId === action.payload) {
                    invoices.splice(i, 1);
                }
            }
            return {
                ...state,
                deleteInvoiceLoading: false,
                deleteInvoiceSuccess: true,
                deleteInvoiceFailure: false,
                deleteInvoiceError: null,
                invoiceList: invoices
            }
        case INVOICE_REQUEST.DELETE_INVOICE_FAILURE:
            return {
                ...state,
                deleteInvoiceLoading: false,
                deleteInvoiceSuccess: false,
                deleteInvoiceFailure: true,
                deleteInvoiceError: action.payload,
            }
        default:
            return state
    }
}